export default {
  // list
  'order_cargo_detail.query.cargoQty': '数量',
  'order_cargo_detail.query.cargoQty.placeholder': '请输入数量',
  'order_cargo_detail.column.orderCargoId': '订单货物ID',
  'order_cargo_detail.column.orderId': '订单ID',
  'order_cargo_detail.column.orderType': '订单类型',
  'order_cargo_detail.column.ladingOrderId': '提单ID',
  'order_cargo_detail.column.cargoQty': '数量',
  'order_cargo_detail.column.cargoWeight': '吨位',
  'order_cargo_detail.column.cargoAttrUniNo': '箱号',
  'order_cargo_detail.column.cargoAttrSealNo': '封签号',
  'order_cargo_detail.column.cargoAttrLoadBoxDate': '装箱日',
  'order_cargo_detail.column.cargoAttrName': '货物名称',
  'order_cargo_detail.column.entryFlag': '是否已入库',
  'order_cargo_detail.column.createBy': '创建人',
  'order_cargo_detail.column.updateBy': '更新人',
  'order_cargo_detail.column.createTime': '创建时间',
  'order_cargo_detail.column.updateTime': '更新时间',
  'order_cargo_detail.column.dataSource': '数据来源',
  'order_cargo_detail.column.remark': '备注',
  'order_cargo_detail.column.status': '状态',
  // edit
  'order_cargo_detail.edit.title': '编辑箱子信息',
  'order_cargo_detail.add.title': '新增箱子信息',
  'order_cargo_detail.edit.success': '编辑成功',
  'order_cargo_detail.add.success': '新增成功',
  'order_cargo_detail.form.cargoQty.required': '数量不能为空',
  'order_cargo_detail.form.cargoWeight.required': '吨位不能为空',
  'order_cargo_detail.form.cargoAttrUniNo.required': '箱号不能为空',
  'order_cargo_detail.form.entryFlag.required': '是否已入库不能为空',
  'order_cargo_detail.form.cargoQty': '数量',
  'order_cargo_detail.form.cargoQty.placeholder': '请输入数量',
  'order_cargo_detail.form.cargoWeight': '吨位',
  'order_cargo_detail.form.cargoWeight.placeholder': '请输入吨位',
  'order_cargo_detail.form.cargoAttr': '货物属性',
  'order_cargo_detail.form.cargoAttrUniNo': '箱号',
  'order_cargo_detail.form.cargoAttrUniNo.placeholder': '请输入唯一箱号',
  'order_cargo_detail.form.cargoAttrSealNo': '封签号',
  'order_cargo_detail.form.cargoAttrSealNo.placeholder': '请输入封签号',
  'order_cargo_detail.form.cargoAttrLoadBoxDate': '装箱日',
  'order_cargo_detail.form.cargoAttrLoadBoxDate.placeholder': '请输入装箱日',
  'order_cargo_detail.form.cargoAttrName': '货物名称',
  'order_cargo_detail.form.cargoAttrName.placeholder': '请输入货物名称',
  'order_cargo_detail.form.entryFlag': '是否已入库',
  'order_cargo_detail.form.entryFlag.placeholder': '请输入是否已入库',
  'order_cargo_detail.form.dataSource': '数据来源',
  'order_cargo_detail.form.dataSource.placeholder': '请输入数据来源',
  'order_cargo_detail.form.remark': '备注',
  'order_cargo_detail.form.remark.placeholder': '请输入备注',
}
